<template>
    <onlyfans-download-form ref="form" v-bind="$props" @download="$emit('download', $event)" websiteName="Redgifs"></onlyfans-download-form>
</template>

<script>
export default {
	props: {
		extensionInfo: Object,
		me: Object,
		loading: Boolean
	}
}
</script>
